



























































































































































































import Session from '@/components/Session.vue';
import ElCard from '@/overrides/ElCard.vue';
export default {
	name: 'login',
	inject: ['responsive'],
	components: {
		Session,
		ElCard,
	},
	data() {
		return {
			showCodigo: false,
			showSession: false,
			loading: false,
			loadingv: false,
			publicPath: process.env.BASE_URL,
			activeName: 'inicio',
			serviceid: '',
			form: {
				user: '',
				password: '',
			},
			formRegister: {
				nombre: '',
				apellido: '',
				email: '',
				password: '',
				cuit: '',
				nrotel: '',
			},
			formCodigo: {
				codigo: '',
			},
			rulescodigo: {
				codigo: [{ min: 6, max: 6, message: 'El código debe tener 6 caracteres', trigger: 'blur' }],
			},
			rules: {
				nombre: [
					{
						required: true,
						message: 'El nombre es obligatorio.',
						trigger: 'blur',
					},
				],
				apellido: [
					{
						required: true,
						message: 'El apellido es obligatorio.',
						trigger: 'blur',
					},
				],
				email: [
					{
						type: 'email',
						required: true,
						message: 'Ingrese un email válido.',
						trigger: 'blur',
					},
				],
				password: [
					{
						required: true,
						message: 'La contraseña es obligatoria.',
						trigger: 'blur',
					},
				],
				nrotel: [
					{
						required: true,
						message: 'Campo numérico obligatorio.',
						trigger: 'blur',
					},
					{ min: 10, max: 10, message: 'Debe contener 10 caracteres', trigger: 'blur' },
				],
			},
		};
	},

	watch: {
		'$route.params.welcome': {
			handler: function (welcome) {
				switch (this.$route.path) {
					case '/welcome':
						this.showSession = false;
						break;
					case '/welcome/sessions':
						this.showSession = true;
						break;
					case '/welcome/new':
						this.showSession = true;
						break;
				}
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		config() {
			return this.$store.state.config.config;
		},
	},
	methods: {
		lowerCase(): void {
			this.form.user = this.form.user.toLowerCase().trim();
		},
		openPoweredBy(): void {
			window.open('https://www.msci.com.ar/msci/', '_blank');
		},
		onSubmitRegister(): void {
			this.$refs.formRegister.validate(valid => {
				if (!valid) return;
				this.loading = true;
				this.$store
					.dispatch('registerLocal', this.formRegister)
					.then(result => {
						if (result.data.success) {
							this.showCodigo = true;
							this.serviceid = result.data.serviceid;
						} else {
							this.$notify.error({
								title: result.data.title,
								message: result.data.msg,
								position: 'top-right',
								duration: 10000,
							});
						}
					})
					.catch(error => {
						this.$notify.error({
							title: 'Error',
							message: 'Error en la creación del usuario',
							position: 'top-right',
							duration: 9000,
						});
					})
					.finally(() => (this.loading = false));
			});
		},
		// validateUser(): void {
		// 	this.loading = true;
		// 	this.$refs.formCodigo.validate(valid => {
		// 		if (!valid) return;
		// 		this.formRegister.codigo = this.formCodigo.codigo;
		// 		this.formRegister.serviceid = this.serviceid;
		// 		this.$store
		// 			.dispatch('checkUsuario', this.formRegister)
		// 			.then(result => {
		// 				if (result.status === 201) {
		// 					this.form.user = this.formRegister.email;
		// 					this.form.password = this.formRegister.password;
		// 					this.onSubmit();
		// 					this.showCodigo = false;
		// 				}
		// 			})
		// 			.catch(error => {
		// 				this.$notify.error({
		// 					title: 'Error',
		// 					message: 'Error en la verificación del numero del usuario',
		// 					position: 'top-right',
		// 				});
		// 			})
		// 			.finally(() => (this.loading = false));
		// 	});
		// },
		async validateUser(): Promise<void> {
			try {
				this.loading = true;
				this.$refs.formCodigo.validate(async valid => {
					if (!valid) return;
					this.formRegister.codigo = this.formCodigo.codigo;
					this.formRegister.serviceid = this.serviceid;
					await this.$store.dispatch('checkUsuario', this.formRegister);
					this.form.user = this.formRegister.email;
					this.form.password = this.formRegister.password;
					this.onSubmit();
					this.showCodigo = false;
					this.loading = false;
				});
			} catch (error) {
				this.loading = false;
				this.$notify.error({
					title: 'Error',
					message: 'Error en la verificación del numero del usuario',
					position: 'top-right',
				});
			}
		},
		async onSubmit(): Promise<void> {
			try {
				this.$refs['form'].validate(async valid => {
					if (!valid) return;
					this.loading = true;
					this.$store.dispatch('authenticate_local', this.form).then(response => {
						if (response) {
							this.activeName = 'inicio';
							this.$refs['formRegister'].resetFields();
							this.formRegister.password = '';
							this.formRegister.cuit = '';
							this.formRegister.nrotel = '';
							this.$router.push('/welcome/sessions');
							this.loading = false;
						} else {
							this.$notify.error({
								title: 'Error',
								message: 'Error en la autenticación ',
								position: 'top-right',
							});
							this.loading = false;
						}
					});
				});
			} catch (error) {
				this.$notify.error({
					title: 'Error',
					message: 'Error en la autenticación',
					position: 'top-right',
				});
				this.loading = false;
			}
		},
		showContact(): void {
			this.$router.push('/forgot');
		},
		async verificationSMS(): Promise<void> {
			try {
				this.loadingv = true;
				const params = { nrotel: this.formRegister.nrotel };
				await this.$store.dispatch('verificationSMS', params).then(result => {
					this.$message('Se ha enviado un nuevo código a ' + this.formRegister.nrotel);
				});
			} catch (error) {
				this.$notify.error({
					title: 'Error',
					message: 'Error al enviar el SMS, vuelva a inentar por favor.',
					position: 'top-right',
					duration: 9000,
				});
			}
			this.loadingv = false;
		},
	},
	mounted(): void {
		this.$store.dispatch('loadConfig');
		this.$route.path === '/welcome/signup' ? (this.activeName = 'registro') : (this.activeName = 'inicio');
	},
};
